<template>
  <div style="padding: 10px;">
    <v-btn class="primary" dark text @click="showDialog">建立代辦合約書</v-btn>

    <agent-contract-view
      :agent-contract-dialog="agentContractDialog"
      @saveContract="saveContract"
    ></agent-contract-view>
  </div>
</template>

<script>
import AgentContractView from "../components/AgentContractView";
import { getUUId } from '../pages/utils/tool';
export default {
  name: 'AgentContractToolView',
  components: { AgentContractView } ,
  data() {
    return {
      agentContractDialog: {
        title: "",
        text: "",
        caseId: "",
        vendorName: "",
        username: "",
        memberId: "",
        cellphone:'',
        address: '',
        bonus: 5,
        auto: false,
        showAuto: false,
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
    }
  },
  methods:{
    showDialog(){
      this.agentContractDialog.visible = true;
      this.agentContractDialog.caseId = getUUId();
      this.agentContractDialog.cancel = () => {
        this.agentContractDialog.visible = false;
      };
    },
    saveContract(data) {
      console.log(`save contract == ${JSON.stringify(data)}`);
      let routeData = this.$router.resolve({
        path: "/AgentContract",
        query: {
          contractId: this.agentContractDialog.caseId,
        },
      });
      window.open(routeData.href, "_blank");
      this.agentContractDialog.visible = false;
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AgentContractToolView.vue